import { withInstall } from '@hd-front-end/utils'
import Mention from './src/mention.vue'

import type { SFCWithInstall } from '@hd-front-end/utils'

export const ElMention: SFCWithInstall<typeof Mention> = withInstall(Mention)
export default ElMention

export * from './src/mention'
